import { useEffect, useState } from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import messageService from "../../services/messageService";
import MessageCard from "./MessageCard";

const CloseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2 2l10 10M12 2L2 12"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const MessagesModal = ({
  open,
  handleClose,
  accountId,
  userId,
  messages = [],
}) => {
  const [expanded, setExpanded] = useState({});
  const [dismissedMessages, setDismissedMessages] = useState([]);

  useEffect(() => {
    if (open) return undefined;
    setExpanded({});
    setDismissedMessages([]);
    return undefined;
  }, [open]);

  const handleExpandClick = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: prev[id] === false ? true : false,
    }));
  };

  const handleDismissMessage = (messageId, checked) => {
    setDismissedMessages((prev) => {
      if (checked) {
        if (prev.includes(messageId)) return prev;
        return [...prev, messageId];
      }
      return prev.filter((id) => id !== messageId);
    });
  };

  const onModalClose = async () => {
    if (dismissedMessages.length > 0 && accountId && userId) {
      try {
        await messageService().dontShowMessageAgain(
          accountId,
          userId,
          dismissedMessages
        );
      } catch {
        // still close — same as legacy modal
      }
    }
    handleClose();
  };

  const onDialogClose = (_event, reason) => {
    if (reason === "backdropClick") return;
    onModalClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onDialogClose}
      aria-labelledby="edsimsV2-messages-dialog-title"
      maxWidth="md"
      fullWidth
      scroll="paper"
      className="edsimsV2-messages-dialog"
      sx={{ zIndex: 1400 }}
      slotProps={{
        paper: { className: "edsimsV2-messages-dialog-paper" },
        backdrop: { className: "edsimsV2-messages-dialog-backdrop" },
      }}
    >
      <Box className="edsimsV2-messages-dialog-header">
        <Box className="edsimsV2-messages-dialog-heading">
          <DialogTitle
            id="edsimsV2-messages-dialog-title"
            className="edsimsV2-messages-dialog-title"
          >
            Announcements
          </DialogTitle>
        </Box>
        <IconButton
          className="edsimsV2-messages-dialog-close"
          onClick={onModalClose}
          aria-label="Close announcements"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent className="edsimsV2-messages-dialog-content">
        {messages.map((message) => (
          <MessageCard
            key={message.id}
            message={message}
            expanded={expanded[message.id] !== false}
            dismissed={dismissedMessages.includes(message.id)}
            onToggleExpand={handleExpandClick}
            onDismissChange={handleDismissMessage}
          />
        ))}
      </DialogContent>
    </Dialog>
  );
};

export default MessagesModal;
